import type { Prototype } from "../prototype-types";

export const kendraConnPrototypes: Prototype[] = [
  {
    id: "brand-join-nudge",
    name: "Brand Join Nudge",
    path: "/kc/brand-join-nudge",
    description:
      "Alert retailer when a brand they know joins Faire — banner on retailer home.",
    owner: "Kendra",
    createdAt: "2026-03-04",
    lastUpdated: "2026-03-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/004ecb49b603659803c92fb85c59f765cb0a5a46e8a7968e84286b62dc4e630e.png",
    creationTool: "cursor",
  },
];
